import { Injectable } from "@angular/core";
import { PrelevementQualifSalle } from "src/app/domain/Qualif/prelevement-qualif-salle";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { AppareilRepository } from "./appareil.repository";
import { PrelevementRepository } from "./prelevement.repository";
import { RepriseRepository } from "./reprise.repository";
import { SoufflageRepository } from "./soufflage.repository";
import { ZoneCompareRepository } from "./zone-compare.repository";
import { PrelevementQualifSalleEntity } from "../prelevement-qualif-salle.entity";
import { ZoneEntity } from "../zone.entity";

@Injectable({
    providedIn: 'root',
})
export class QualifSalleRepository {

    constructor(private prelevementRepository: PrelevementRepository,
        private appareilRepository: AppareilRepository,
        private soufflageRepository: SoufflageRepository,
        private repriseRepository: RepriseRepository,
        private zoneCompareRepository: ZoneCompareRepository,

    ) { }

    async getQualifSalleEntityById(id: number) {
        return await db.prelevementQualifSalles.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async getQualifSalleEntityByCode(code: string) {
        return await db.prelevementQualifSalles.where('Code').equals(code).first(async me => {
            return me;
        });
    }

    async getQualifSalleById(id: number) {
        return await db.prelevementQualifSalles.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, PrelevementQualifSalleEntity, PrelevementQualifSalle);

            if (ze?.PrelevementId) {
                z.Prelevement = await this.prelevementRepository.getPrelevementById(ze?.PrelevementId)
            }

            if (ze?.SoufflageIds) {
                for (let i = 0; i < ze.SoufflageIds.length; i++) {
                    z.SoufflageList.push(await this.soufflageRepository.getSoufflageById(ze.SoufflageIds[i]));
                }
            }

            if (ze?.RepriseIds) {
                for (let i = 0; i < ze.RepriseIds.length; i++) {
                    z.RepriseList.push(await this.repriseRepository.getRepriseById(ze.RepriseIds[i]));
                }
            }

            if (ze?.ZoneCompareIds) {
                for (let i = 0; i < ze.ZoneCompareIds.length; i++) {
                    z.ZoneAComparerList.push(await this.zoneCompareRepository.getZoneCompareById(ze.ZoneCompareIds[i]));
                }
            }

            if (ze?.ZoneCompareSasIds) {
                for (let i = 0; i < ze.ZoneCompareSasIds.length; i++) {
                    z.ZoneAComparerSasList.push(await this.zoneCompareRepository.getZoneCompareById(ze.ZoneCompareSasIds[i]));
                }
            }
            return z;
        });
    }

    async attachQualifSalle(ps: PrelevementQualifSalle, zoneEntity: ZoneEntity) {
        let pqsId: number;
        const pqse = mapper.map(ps, PrelevementQualifSalle, PrelevementQualifSalleEntity);

        // const ze = await this.zoneRepository.getZoneEntityById(zoneEntity);
        pqse.Id = await db.prelevementQualifSalles.add(pqse);
        await db.zones.update(zoneEntity.Id!, {
            PrelevementQualifSalleId: pqse.Id
        });

        if (ps.Prelevement) {
            await this.prelevementRepository.attachPrelevementToQualifSalle(ps.Prelevement, pqse);
        }

        // if (ps.AppareilQualifList?.length > 0) {
        //     for (let i = 0; i < ps.AppareilQualifList?.length; i++) {
        //         await this.appareilRepository.attachAppareil(ps.AppareilQualifList[i], pqse);
        //     }
        // }

        if (ps.SoufflageList?.length > 0) {
            for (let i = 0; i < ps.SoufflageList?.length; i++) {
                await this.soufflageRepository.attachSoufflage(ps.SoufflageList[i], pqse);
            }
        }

        if (ps.RepriseList?.length > 0) {
            for (let i = 0; i < ps.RepriseList?.length; i++) {
                await this.repriseRepository.attachReprise(ps.RepriseList[i], pqse);
            }
        }

        if (ps.ZoneAComparerList?.length > 0) {
            for (let i = 0; i < ps.ZoneAComparerList?.length; i++) {
                await this.zoneCompareRepository.attachZoneCompare(ps.ZoneAComparerList[i], pqse);
            }
        }
        return pqse.Id;
    }
}